export interface MediaCollectionItem {
  url: string;
  kind: 'image' | 'video';
  name: string;
}

export interface MediaCollection {
  items: readonly MediaCollectionItem[];
  index: number;
}

export function mediaCollection(items: readonly MediaCollectionItem[], index: number): MediaCollection | null {
  if (items.length < 2) return null;
  return {
    items: items.map((item) => ({ ...item })),
    index: Number.isInteger(index) ? Math.max(0, Math.min(index, items.length - 1)) : 0,
  };
}

export function selectCollectionItem(collection: MediaCollection, index: number): MediaCollection {
  if (!Number.isInteger(index) || index < 0 || index >= collection.items.length || index === collection.index) return collection;
  return { ...collection, index };
}
